import { render, staticRenderFns } from "./InvestorPartnerInfoForm.vue?vue&type=template&id=3d07cc12"
import script from "./InvestorPartnerInfoForm.vue?vue&type=script&lang=js"
export * from "./InvestorPartnerInfoForm.vue?vue&type=script&lang=js"
import style0 from "./InvestorPartnerInfoForm.vue?vue&type=style&index=0&id=3d07cc12&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports